/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsFavoriteChampionDtoSchema = z.object({
  name: z.string().nullish(),
  image: z.string().nullish(),
  imageUrl: z.string().nullish(),
  games: z.optional(z.int()),
  winrate: z.optional(z.number()),
});
